<template>
    <div class="cpf-modal-container">
        <div class="bg">
            <h2 v-if="blockCnpjPdv">{{ getString('informe_cpf') }} </h2>
            <h2 v-else>{{ getString('informe_cpf_cnpj') }} </h2>
            <div class="radios" v-if="!blockCnpjPdv">
                <div class="container-input">
                    <input type="radio" class="styled-input" :class="{'selected' : true}" name="informa_cpf" id="cpf" checked value="cpf" v-model="dynamicMask">
                    <span class="checkmark"></span>
                </div>
                <label for="cpf">{{ getString('CPF') }}</label>

                <div class="container-input" >
                    <input type="radio" class="styled-input" name="informa_cpf" id="cnpj" value="cnpj" v-model="dynamicMask">
                    <span class="checkmark"></span>
                </div>
                <label for="cnpj" v-if="!blockCnpjPdv">{{ getString('CNPJ') }}</label>
            </div>
            <div class="input-container" :class="hasError ? 'error-shake' : ''">
                <div id="cpf-cnpj" class="div-input-android" :class="{'error-signal': hasError}"></div>
                <span v-if="errorMessage" class="error-message"> {{ errorMessage }}</span>
            </div>
            <div class="buttons-container">
                <DefaultButton v-for="(btn, key) in buttons" :key="key"
                    :text="btn.text" @defaultBtnClick="btn.action()" class="buttons">
                </DefaultButton>
            </div>

            <div class="overlay" v-if="showCepModal"></div>
                <Transition name="fade">
                <CepModalGom v-if="showCepModal" @closeCepModal="showCepModal = false" @address="handleAddressData" />
                </Transition>

            <AndroidKeyboard id="android-keyboard"
                :inputElement="inputElement"
                :layout="dynamicMask === 'cpf' ? layout : alphanumericLayout"
                :bigNumeric="dynamicMask === 'cpf'"
                :roundNumeric="dynamicMask === 'cpf'"
                :onInput="applyMask"
                :maxCaracteres="dynamicMask === 'cpf' ? 14 : 18">
            </AndroidKeyboard>
        </div>
    </div>
 </template>

<script>
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton.vue'
import ValidaCpfCnpj from '@/assets/libs/cpfcnpj'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import LocaleController from '@/assets/controllers/LocaleController'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import CepModalGom from '@/components/CepModalGom.vue'

export default {
    name: 'CPFModalGom',
    components: {
        DefaultButton,
        AndroidKeyboard,
        CepModalGom
    },
    props: ['cpf'],
    data () {
        return {
            cpfValue: '',
            cnpjValue: '',
            inputElement: null,
            visible: false,
            hasError: false,
            showCepModal: false,
            errorMessage: '',
            layout: keyboardLayout.SIMPLE_PHONE_NUMBER,
            alphanumericLayout: keyboardLayout.ALPHANUMERIC_CNPJ,
            input: null,
            dynamicMask: 'cpf',
            idCliValue: '',
            blockCnpjPdv: Util.getLocalConfigs('blockCnpjPdv'),
            options: {
                useKbEvents: false,
                preventClickEvent: false
            },
            buttons: [
                {
                    text: this.getString('nao_informar'),
                    action: this.cancel
                },
                {
                    text: this.getString('confirmar'),
                    action: this.confirm
                }
            ]
        }
    },
    mounted () {
        this.inputElement = document.getElementById('cpf-cnpj')
        if (this.cpf) {
            if (this.cpf.length > 14) {
                this.cnpjValue = this.cpf
                this._isInitializing = true
                this.dynamicMask = 'cnpj'
            } else {
                this.cpfValue = this.cpf
                this.idCliValue = this.cpf
                this.inputElement.innerText = this.cpf
            }
            this.buttons[0].text = this.getString('remover')
        }
    },
    watch: {
        dynamicMask: function (newmask, oldmask) {
            this.errorMessage = ''
            this.hasError = false

            if (!this._isInitializing) {
                if (oldmask === 'cpf') this.cpfValue = this.idCliValue
                else this.cnpjValue = this.idCliValue
            }
            this._isInitializing = false

            const restored = newmask === 'cpf' ? this.cpfValue : this.cnpjValue
            this.idCliValue = restored
            if (this.inputElement) this.inputElement.innerText = restored
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        hide: function () {
            this.visible = false
        },
        cancel: function () {
            if (this.cpf) {
                this.idCliValue = ''
                this.$emit('setIdCliValue', this.idCliValue)
            }
            this.$emit('closeCpfModal')
        },
        confirm: async function () {
            this.idCliValue = document.getElementById('cpf-cnpj').innerText
            if (!ValidaCpfCnpj.validaCpfCnpj(this.idCliValue)) {
                this.errorMessage = this.getString('CPF_CNPJ_invalido')
                console.log('CPF/CNPJ invalido')
                this.showError()
                return false
            }

            if (this.dynamicMask === 'cnpj') {
                const dtPortariaNfce = Util.getLocalConfigs('dtPortariaNfce')
                if (!dtPortariaNfce) {
                    this.$emit('setIdCliValue', this.idCliValue)
                    return false
                }
                if (dtPortariaNfce) {
                    const portariaDate = new Date(dtPortariaNfce)
                    const today = new Date()
                    if (portariaDate > today) {
                        this.$emit('setIdCliValue', this.idCliValue)
                    } else {
                        this.showCepModal = true
                    }
                }
            } else {
                this.$emit('setIdCliValue', this.idCliValue)
            }
        },
        showError: function () {
            this.hasError = true
            const sf = this
            sf.hasError = true
            setTimeout(() => {
                sf.hasError = false
            }, 1000)
        },
        sanitizeCpfCnpj: function () {
            this.errorMessage = ''
            if (this.dynamicMask === 'cpf') {
                this.idCliValue = this.idCliValue.replace(/[^0-9.-]+/g, '')
            } else {
                this.idCliValue = this.idCliValue.replace(/[^A-Z0-9/.-]+/g, '').toUpperCase()
            }
        },
        applyMask: function (input) {
            if (!input) return ''

            if (this.dynamicMask === 'cpf') {
                input = input.replace(/\D/g, '')
                return this.applyCpfMask(input)
            } else {
                input = input.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
                return this.applyCnpjMask(input)
            }
        },
        applyCpfMask: function (input) {
            if (input.length < 7) {
                return input.replace(/(\d{3})(\d)/, '$1.$2')
            } else if (input.length >= 7 && input.length < 10) {
                return input.replace(/(\d{3})(\d{3})(\d)/, '$1.$2.$3')
            } else {
                return input.replace(/(\d{3})(\d{3})(\d{3})(\d)/, '$1.$2.$3-$4')
            }
        },
        applyCnpjMask: function (input) {
            if (input.length < 6) {
                return input.replace(/([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
            } else if (input.length >= 6 && input.length < 9) {
                return input.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
            } else if (input.length >= 9 && input.length < 13) {
                return input.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3/$4')
            } else {
                return input.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/, '$1.$2.$3/$4-$5')
            }
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        handleAddressData: function (addressData) {
            this.showCepModal = false

            this.$emit('setIdCliValue', this.idCliValue, addressData)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
     @import (reference) url("../assets/common.less");
     .cpf-modal-container {
        height: 100%;
        width: 100%;
        .bg {
            position: relative;
            background: white;
            padding: 0 85px;
            display: grid;
            grid-template-rows: 100px 90px 150px 150px auto;
            height: 100%;
            align-items: center;
            // opacity: 1;
            .radios {
                    text-align: center;
                    font-size: 2rem;
                    // margin-bottom: 2rem;

                    input {
                        margin-left: 2rem;
                    }
                    .container-input {
                        height: 40px;
                        display: inline-block;
                        vertical-align: middle;
                        #cpf, #cnpj{
                            margin: 0;
                        }
                        .checkmark {
                            margin: 0;
                            border-radius: 100%;
                            pointer-events: none;
                            height: 40px;
                            width: 40px;
                            &:before {
                                width: 10px;
                                height: 10px;
                                border: solid 18px @primary-color;
                            }
                            &:after {
                                border: none;
                                // background: white;
                                background-color: @primary-color;
                                border-radius: 100%;
                                width: 20px;
                                left: 10px;
                                top: 10px;
                            }
                        }
                    }
                    label {
                        display: inline-block;
                        vertical-align: middle;
                        font-size: 2rem;
                        &:not(&:last-of-type) {
                            margin-right: 30px;
                        }
                    }
                }
            img {
                display: block;
                margin: auto;
                width: 100px;
                height: 100px;
                border: solid 1px;
                border-radius: 100%;
                object-fit: contain;
                padding: 10px;
            }
            h2, span, img {
                display: block;
                font-size: 2.5rem;
                margin: auto;
                text-align: center;
                color: @primary-dark;
            }
            h2, span.qst {
                // margin: 15px 0;
                font-weight: bold;
            }
            .input-container {
               //  margin: 40px 0;
                text-align: center;

                .div-input-android {
                    z-index: 1;
                    position: relative;
                    // margin: 15px 40px;
                    margin: 0 30px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 3.5rem;
                    height: 85px;
                    background-color: white;
                    color: black;
                    border: 2px solid black;
                    border-radius: 20px;
                    padding: 0 20px;
                }
                .error-signal {
                    border: 4px solid red;
                }
                &.error-shake {
                    input {
                        background-color: rgba(250, 9, 9, 0.397);
                    }
                    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
                    transform: translate3d(0, 0, 0);
                }
            }
            .buttons-container {
                // margin: 50px 45px 30px 45px;
                margin: 0 30px;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-content: center;
                justify-content: space-between;
                align-items: center;
                .button-default {
                    width: 45%;
                }
                button:first-of-type{
                    background: white;
                    border: solid 1px black;
                    color: black;
                }
            }
            .keyboard-container {
                align-self: self-start;
                margin-top: 30px;
            }
        }
     #keyboard {
        .keyboard;
        .keyboard-gom;
         width: inherit;
         max-width: 930px;
         top: inherit;
         position: unset;
         bottom: 0;
        }
    }

     @keyframes shake {
         10%,
         90% {
             transform: translate3d(-1px, 0, 0);
         }

         20%,
         80% {
             transform: translate3d(2px, 0, 0);
         }

         30%,
         50%,
         70% {
             transform: translate3d(-4px, 0, 0);
         }

         40%,
         60% {
             transform: translate3d(4px, 0, 0);
         }
     }

@media (min-width: 699px) and (max-width: 1025px) { //@tablet
    .cpf-modal-container{
        width: 100%;
            .bg {
                grid-template-rows: 70px 70px 100px 120px auto;
                padding: 0 25px;
                .buttons-container {
                    width: 100%;
                    margin: 30px 0;
                    justify-content: space-evenly;
                    button {
                        min-width: 230px;
                    }
                }
                .input-container {
                    margin: 40px 0;
                    text-align: center;
                    .div-input-android {
                        font-size: 3rem;
                        height: 65px;
                    }
                    .error-message {
                        font-size: 20px;
                    }
                }
                .radios {
                    text-align: center;
                    font-size: 1.8rem;
                    .container-input {
                        .checkmark {
                            height: 35px;
                            width: 35px;
                            &:before {
                                width: 10px;
                                height: 10px;
                                border: solid 15px @primary-color;
                            }
                        }
                    }
                }
                h2 {
                    font-size: 2.2rem;
                }
                .keyboard-container {
                    margin-top: 10px;
                }
        }
    }
}
@media (max-width: 698px) { // Gertec SK210
    .cpf-modal-container{
        width: 100%;
        .bg {
            align-items: center;
            grid-template-rows: 40px 40px 65px 65px auto;
            padding: 5px 30px !important;
            h2 {
                font-size: 22px;
            }
            padding: 20px 30px;
            .buttons-container {
                width: 100%;
                margin: 0 0;
                justify-content: space-between;
                button {
                    min-width: 45% !important;
                }
            }
            .input-container {
                margin: 0 0;
                text-align: center;
                .div-input-android {
                    font-size: 25px;
                    height: 35px;
                    border-radius: 8px;
                    margin: 0 0;
                }
                .error-message {
                    font-size: 14px;
                }
            }
            .radios {
                font-size: 15px;

                    input {
                        margin-left: 0;
                    }
                    .container-input {
                        height: 20px;
                        .checkmark {
                            height: 20px;
                            width: 20px;
                        }
                        input[type="radio"] ~ .checkmark::before {
                            width: 8px;
                            height: 8px;
                            border: solid 8px @primary-color;
                        }
                    }
                    label {
                        display: inline-block;
                        vertical-align: middle;
                        font-size: 15px;
                        &:not(&:last-of-type) {
                            margin-right: 30px;
                        }
                    }
                }
            .keyboard-container {
                align-self: self-center;
                margin-top: 5px;
            }
        }
    }
}
@media (orientation: landscape) {
    .cpf-modal-container{
        width: 100%;
            .bg {
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-template-rows: 50px 50px 100px auto;
                grid-template-areas:
                    "title keyboard"
                    "radios keyboard"
                    "input keyboard"
                    "buttons keyboard";
                padding: 0 25px;
                column-gap: 30px;
                align-items: start;
                height: 100%;
                align-content: center;
                h2 {
                    grid-area: title;
                    font-size: 1.6rem;
                    margin: 10px 0;
                }

                .radios {
                    grid-area: radios;
                    font-size: 1.4rem;
                    margin: 10px 0;
                    label {
                        font-size: 1.6rem;
                    }
                    .container-input {
                        .checkmark {
                            height: 25px;
                            width: 25px;
                            &:before {
                                width: 10px;
                                height: 10px;
                                border: solid 10px @primary-color;
                            }
                        }
                    }
                }

                .input-container {
                    grid-area: input;
                    margin: 20px 0;
                    text-align: center;
                    .div-input-android {
                        font-size: 2.2rem;
                        height: 50px;
                        margin: 0;
                        border: solid 1px rgba(0, 0, 0, 0.5);
                    }
                    .error-message {
                        font-size: 20px;
                    }
                }

                .buttons-container {
                    grid-area: buttons;
                    width: 100%;
                    margin: 20px 0;
                    flex-direction: column-reverse;
                    flex-wrap: wrap;
                    gap: 15px;
                    button {
                        min-width: 100%;
                    }
                }

                #android-keyboard {
                    grid-area: keyboard;
                    align-self: start;
                    margin: 0;
                }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CPFModalGom.vue